import { Box } from "@mui/material";
import { CalendarList } from "../../layer21";

export type CalendarActivityDetailSectionProps = {};

export const CalendarActivityDetailSection = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap=".75rem"
      marginTop=".75rem"
    >
      <CalendarList />
    </Box>
  );
};
